import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import jwtDecode from 'jwt-decode';
import axios from 'axios';
import { appUrl } from '../../../../../../../utils/config';
import StyledButton from '../../../../../../common/models/Button';
import Header from '../../../models/Header';
import FullWidthContent from '../../../wrappers/QuickViewWrapper';
import General from '../../batch/updateBatch/General';
import ProducedBatchInformation from '../../batch/updateBatch/producedBatchInformation';
import PreShipmentInformation from '../../batch/updateBatch/PreShipmentInformation';
import ConsumedBatchInformation from '../../batch/updateBatch/ConsumedBatchInformation';
import PostShipmentInformation from '../../batch/updateBatch/PostShipmentInformation';
import QualityAssuranceInformation from '../../batch/updateBatch/QCAndShipping/QualityAssuranceInformation';
import ASLCheckDetails from '../../batch/updateBatch/ASLCheckDetails';
import { fetchDSBatchDetails } from '../../../../../containers/actions/common/saslAction';
import { downloadCustomUploadedFile } from '../../../../../containers/actions/common/fileActions';
import ShowFiles from '../../../models/files/ShowFiles';
import { getFeaturesAccess } from '../../../../../containers/actions/common/accessControl';
import ShippingInformation from '../../batch/updateBatch/QCAndShipping/ShippingInformation';
import FileUploads from '../../batch/updateBatch/FileUploads';
import { ViewBatchPageButtons } from '../../batch/updateBatch/ViewBatchPageButtons';
import ApproveRejectConsumedBatch from '../../../PurchaseOrderDashbaordIndex/ApproveRejectConsumedBatch';
import BatchProgressBar from '../../batch/updateBatch/BatchProgressBar';

const useStyles = (theme) => ({
  list: {
    maxWidth: '100vw',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100vw',
    },
  },
  fullList: {
    width: 'auto',
  },
  received: {
    textAlign: 'left',
  },
  grid: {
    paddingBottom: '2rem',
    paddingRight: '1.5rem',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
  },
  tableContainer: {
    marginTop: theme.spacing(0),
    boxShadow: 'none',
    borderRadius: '0px',
    border: '1px solid #E0E0E0',
    backgroundColor: '#fff',
    maxWidth: '800px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  tableHeader: {
    backgroundColor: '#F5F5F5',
  },
  headerCell: {
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#333',
    padding: '8px 10px',
    borderBottom: '1px solid #E0E0E0',
    whiteSpace: 'nowrap',
  },
  tableRow: {
    backgroundColor: '#fff',
  },
  tableCell: {
    fontSize: '14px',
    color: '#333',
    padding: '6px 10px',
    borderBottom: '1px solid #E0E0E0',
    whiteSpace: 'nowrap',
  },
  link: {
    color: '#1976D2',
    cursor: 'pointer',
    textDecoration: 'pointer',
    fontWeight: 500,
  },
});

class QuickView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: {},
      openApproveRejectBatch: false,
      selectedBatch: null,
      partialShippingDetails: [],
      selectedBatchIndex: 0, // For inactive PO batch tabs
    };
  }


  componentDidMount() {
    // Initialize feature access for batch components
    if (!this.props.fgBatchFeatures)
      this.props.getFeaturesAccess(this.props.fgBatchScreenAccess?.screenId, 'fgBatchFeatures');
    
    // Handle logistics dashboard - no screen-access gate needed
    if (this.props.isFromLogisticsDashboard && this.props.schrockenDeliveryScheduleBatchID) {
      this.props.fetchDSBatchDetails({
        schrockenDeliveryScheduleBatchID: this.props.schrockenDeliveryScheduleBatchID,
      });
      return;
    }

    // Handle inactive PO module - use first batch by default
    if (this.props.isFromInactivePO && this.props.inactivePOBatchDetails && this.props.inactivePOBatchDetails.length > 0) {
      const firstBatch = this.props.inactivePOBatchDetails[0];
      if (firstBatch?.schrockenDeliveryScheduleBatchID && this.props.fgBatchScreenAccess?.screenAccess) {
        const data = {
          schrockenDeliveryScheduleBatchID: firstBatch.schrockenDeliveryScheduleBatchID,
        };
        this.props.fetchDSBatchDetails(data);
      }
      return;
    }

    // Always use fetchDSBatchDetails API regardless of data source
    const batchId = this.props.isFromPoDashboard
      ? this.props.poRowData?.batchDetails?.schrockenDeliveryScheduleBatchID
      : this.props.schrockenDeliveryScheduleBatchID;

    if (batchId && this.props.fgBatchScreenAccess?.screenAccess) {
      // Call fetchDSBatchDetails API
      const data = {
        schrockenDeliveryScheduleBatchID: batchId,
        // cmoBatchNumber: cmoBatchNumber,
      };
      this.props.fetchDSBatchDetails(data);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.DsDetails && this.props.DsDetails !== prevProps.DsDetails) {
      const batchData = this.props.DsDetails.data;
      
      // Extract partialShippingDetails from batch data
      const partialShippingDetails = batchData.partialShippingDetails || [];
      const asnNumber = batchData.asnNumber || null;
      
      const selectedBatch = {
        scheduleAgreementNumber: batchData.scheduleAgreementNumber,
        vendorBatchNumber: batchData.vendorBatchNumber,
        producedQuantity: parseFloat(batchData.producedQuantity) || 0,
        batchUOM: batchData.batchUOM,
        batchSize: parseFloat(batchData.batchSize) || 0,
        SASLBatchStatusID: batchData.SASLBatchStatusID,
        statusDisplayName: batchData.statusDisplayName,
        fgMaterialName: batchData.fgMaterialName,
        fgMaterialCode: batchData.fgMaterialCode,
        brandOwnerMosymphonyID: batchData.brandOwnerMosymphonyID,
        vendorMosymphonyID: batchData.vendorMosymphonyID,
        brandOwnerName: batchData.sponsorOrgName || batchData.brandOwnerName,
        readyForDispatchQuantity: parseFloat(batchData.readyForDispatchQuantity) || 0,
        dispatchQuantity: parseFloat(batchData.dispatchQuantity) || 0,
        bomConsumptionAddedIndicator: batchData.bomConsumptionAddedIndicator,
        pendingQuantity: batchData.pendingQuantity || 0,
        scheduleLineItemNumber: batchData.scheduleLineItemNumber,
        schrockenDeliveryScheduleID: batchData.schrockenDeliveryScheduleID,
        schrockenDeliveryScheduleBatchID: batchData.schrockenDeliveryScheduleBatchID,
        batchStartDate: batchData.batchStartDate,
        batchEndDate: batchData.batchEndDate,
        uomQA: batchData.uomQA,
        Yield: parseFloat(batchData.yield) || 0,
        BOGeneratedGRNNumber: batchData.BOGeneratedGRNNumber
      };
      
      this.setState({ 
        data: { ...batchData, hasBatchData: true }, 
        loading: false, 
        selectedBatch,
        partialShippingDetails,
        asnNumber,
      });
    }

    if (this.props.selectedBatch && this.props.selectedBatch !== prevProps.selectedBatch) {
      this.setState({ selectedBatch: this.props.selectedBatch });
    }
  }

  // Method to fetch batches data from API
  // fetchBatchesData = () => {
  //   this.setState({ isLoadingBatches: true });
    
  //   // Use default parameters for fetching all batches
  //   const data = {
  //     statusID: ["all"],
  //     vendorMosymphonyID: "all",
  //     searchByNumber: "",
  //     searchByProductCode: "",
  //     BSDStartDate: null,
  //     BSDEndDate: null,
  //     pageSize: 10,
  //     pageNumber: 1,
  //     qaStatusID: "all",
  //   };

  //   this.props.fetchBatches(data);



  dialogClosClearData = () => {
    this.props.setDialogOpen();
    this.setState({ loading: true, data: null });
  };

  convertToLocaleDateTime = (dateTime) => {
    if (!dateTime) return 'N/A';
    try {
      let date;
      if (typeof dateTime === 'string') {
        if (dateTime.includes('T')) {
          date = new Date(dateTime);
        } else {
          const parts = dateTime.split(/[-/]/);
          if (parts.length >= 3) {
            date = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
          } else {
            date = new Date(dateTime);
          }
        }
      } else {
        date = new Date(dateTime);
      }

      if (isNaN(date.getTime())) {
        return 'N/A';
      }

      const day = date.getDate();
      const month = date.getMonth();
      const year = date.getFullYear();
      const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
      
      return `${day}-${monthNames[month]}-${year}`;
    } catch (error) {
      return 'N/A';
    }
  };

  handleDownloadFile = (fileID) => {
    const data = {
      ...this.props.params,
      schrockenCustomFileID: fileID,
    };
    this.props.downloadCustomUploadedFile(data);
  };

  handleOpenApproveRejectBatch = () => {
    this.setState({ openApproveRejectBatch: true });
  };

  handleCloseApproveRejectBatch = () => {
    this.setState({ openApproveRejectBatch: false });
  };

  handleRefreshData = (refreshType) => {
    let batchId;

    if (this.props.isFromLogisticsDashboard) {
      batchId = this.props.schrockenDeliveryScheduleBatchID;
    } else if (this.props.isFromInactivePO && this.props.inactivePOBatchDetails && this.props.inactivePOBatchDetails.length > this.state.selectedBatchIndex) {
      batchId = this.props.inactivePOBatchDetails[this.state.selectedBatchIndex]?.schrockenDeliveryScheduleBatchID;
    } else if (this.props.isFromPoDashboard) {
      batchId = this.props.poRowData?.batchDetails?.schrockenDeliveryScheduleBatchID;
    } else {
      batchId = this.props.schrockenDeliveryScheduleBatchID;
    }
      
    const cmoBatchNumber = this.props.isFromPoDashboard
      ? this.props.poRowData?.batchDetails?.cmoBatchNumber
      : this.props.batchRowData?.cmoBatchNumber || this.state.data?.cmoBatchNumber;

    const data = {
      schrockenDeliveryScheduleBatchID: batchId,
      // cmoBatchNumber: cmoBatchNumber,
    };
    
    if (this.props.isFromLogisticsDashboard || this.props.fgBatchScreenAccess?.screenAccess) {
      this.props.fetchDSBatchDetails(data);
    }

    this.handleCloseApproveRejectBatch();
  };

  handleBatchSwitch = (batchIndex) => {
    if (this.props.isFromInactivePO && this.props.inactivePOBatchDetails && this.props.inactivePOBatchDetails.length > batchIndex) {
      const selectedBatch = this.props.inactivePOBatchDetails[batchIndex];
      if (selectedBatch?.schrockenDeliveryScheduleBatchID && this.props.fgBatchScreenAccess?.screenAccess) {
        this.setState({ 
          selectedBatchIndex: batchIndex,
          loading: true,
          data: {},
        });
        const data = {
          schrockenDeliveryScheduleBatchID: selectedBatch.schrockenDeliveryScheduleBatchID,
        };
        this.props.fetchDSBatchDetails(data);
      }
    }
  };

  render() {
    const { classes, isApprovedButton } = this.props;
    const { loading, data } = this.state;
    const { existingCOAFiles, existingCustomFiles, existingEInvoiceFiles, existingEWayBillFiles } = data || {};

    const cmoBatchNumber = this.props.DsDetails?.data?.cmoBatchNumber;

    // Extract current and next status from progressBar - match BatchProgressBar logic
    let currentStatusText = data?.statusDisplayName || '-';
    let nextStatusText = '-';
    
    if (data?.progressBar?.statusSequence && Array.isArray(data.progressBar.statusSequence)) {
      // Sort by sequence number to ensure correct order (same as BatchProgressBar)
      const sortedStatusSequence = [...data?.progressBar.statusSequence].sort((a, b) => 
        (a.sequence || 0) - (b.sequence || 0)
      );
      
      // Find current status index
      const currentIndex = sortedStatusSequence.findIndex(status => status.state === 'current');
      
      if (currentIndex !== -1) {
        currentStatusText = sortedStatusSequence[currentIndex].statusName;
        
        // Find upcoming status: prefer backend state, fallback to next item after current
        const upcomingIndex = sortedStatusSequence.findIndex(status => status.state === 'upcoming');
        const calculatedUpcomingIndex = upcomingIndex === -1 && currentIndex !== -1 
          ? currentIndex + 1 
          : upcomingIndex;
          
        if (calculatedUpcomingIndex !== -1 && calculatedUpcomingIndex < sortedStatusSequence.length) {
          nextStatusText = sortedStatusSequence[calculatedUpcomingIndex].statusName;
        }
      }
    }

    const allFiles = [
      ...(existingCOAFiles?.length ? existingCOAFiles : []),
      ...(existingCustomFiles?.length ? existingCustomFiles : []),
      ...(existingEInvoiceFiles?.length ? existingEInvoiceFiles : []),
      ...(existingEWayBillFiles?.length ? existingEWayBillFiles : []),
    ];

    const fileTypeOrder = [
      "BMR",
      "COC",
      "dsbatch_coa",
      "packingList",
      "proformaInvoice",
      "eInvoice"
    ];

    const sortedFiles = allFiles?.sort((a, b) => {
      return fileTypeOrder.indexOf(a.customFileType) - fileTypeOrder.indexOf(b.customFileType);
    });

    const doubleSortedFiles = sortedFiles.filter(file => file?.customFileType !== "custom");

    const formatDocumentName = (fileName) => {
      return fileName.split(".")[0];
    };

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .replace(/\s/g, "-")
        .toUpperCase();
    };

    let showApproveButton = null;
    if (this.props.isFromPoDashboard) {
      showApproveButton = false
    } else if (isApprovedButton) {
      showApproveButton = true
    } else {
      showApproveButton = false
    }

    return (
      <div className={classes.list} role='presentation'>
        <Header
          title='View Batch Info'
          isDrawer={true}
          handleClose={this.dialogClosClearData}
        >
          <FullWidthContent >
            {/* Batch Tabs for Inactive PO Module */}
            {this.props.isFromInactivePO && this.props.inactivePOBatchDetails && this.props.inactivePOBatchDetails.length > 1 && (
              <Grid container style={{ padding: '1rem 1rem 0.5rem 1rem', borderBottom: '1px solid #E0E0E0' }}>
                <Grid item xs={12}>
                  <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', alignItems: 'center' }}>
                    {this.props.inactivePOBatchDetails.map((batch, index) => {
                      const batchNumber = batch.vendorBatchNumber || batch.batchNumber || `Batch ${index + 1}`;
                      const isSelected = this.state.selectedBatchIndex === index;
                      return (
                        <span
                          key={index}
                          onClick={() => this.handleBatchSwitch(index)}
                          style={{
                            padding: '0.25rem 0.5rem',
                            cursor: 'pointer',
                            borderBottom: isSelected ? '2px solid #1976D2' : '2px solid transparent',
                            color: isSelected ? '#1976D2' : '#666',
                            fontWeight: 700, // Same as application labels
                            fontSize: '1rem', // Same as application labels
                            textDecoration: 'none',
                            userSelect: 'none',
                            fontFamily: 'Roboto, sans-serif',
                          }}
                        >
                          Batch {batchNumber}
                        </span>
                      );
                    })}
                  </div>
                </Grid>
              </Grid>
            )}
            <Grid container style={{ padding: '0 1rem 1rem 1rem' }}>
              <Grid item xs={12} sm={12}>
                {/* Buttons Section - Above the gray bordered area */}
                <Grid container justifyContent="flex-end" style={{ marginBottom: '1rem' }}>
                  <Grid item>
                    <ViewBatchPageButtons
                      batchDetails={data}
                      cmoBatchNumber={cmoBatchNumber}
                      schrockenDeliveryScheduleID={this.props.schrockenDeliveryScheduleID}
                      featureAccess={this.props.fgBatchFeatures}
                      targetQuantity={this.props.targetQuantity || this.props.poQuantity}
                    />
                  </Grid>
                </Grid>
                
                {/* Gray bordered section with Current Status, Next Status, and Progress Bar */}
                <Grid
                  ref={(el) => {
                    this.el = el;
                  }}
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ 
                    backgroundColor: '#FAFAFA', 
                    padding: '1rem',
                    marginBottom: data?.progressBar ? '20px' : '0',
                    border: '1px solid #D0D0D0',
                    borderRadius: '4px'
                  }}
                >
                  <Grid
                    container
                    spacing={3}
                    style={{ justifyContent: 'space-between' }}
                  >
                    {data?.progressBar ? (
                      <Grid item xs={12} sm={12}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={6} md={4}>
                            <Typography variant='body2' style={{ fontSize: '1rem', fontWeight: 700 }}>
                              Current Status
                            </Typography>
                            <Typography
                              variant='body2'
                              style={{ fontSize: '1rem', paddingTop: '0.5rem' }}
                            >
                              {currentStatusText}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <Typography variant='body2' style={{ fontSize: '1rem', fontWeight: 700 }}>
                              Next Status
                            </Typography>
                            <Typography
                              variant='body2'
                              style={{ fontSize: '1rem', paddingTop: '0.5rem' }}
                            >
                              {nextStatusText}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container style={{ paddingTop: '0.5rem' }}>
                          <Grid item xs={12}>
                            <Typography 
                              variant='body2' 
                              style={{ 
                                fontSize: '0.875rem', 
                                fontStyle: 'italic',
                                color: '#666'
                              }}
                            >
                              Hover over the circle to see the status.
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    ) : (
                      <>
                        <Grid item xs={3} sm={3}>
                          <Typography variant='body2' style={{ fontSize: '1rem', fontWeight: 500 }}>
                            Current Status
                          </Typography>
                          <Typography
                            variant='body2'
                            style={{ fontSize: '1rem', paddingTop: '1rem' }}
                          >
                            {data?.statusDisplayName ? data?.statusDisplayName : '-'}
                          </Typography>
                        </Grid>
                        {this.props.qualityApprovalFlowFlag && (
                          <Grid item xs={3} sm={3}>
                            <Typography
                              variant='body2'
                              style={{ fontSize: '1rem', fontWeight: 500 }}
                            >
                              QA Status
                            </Typography>
                            <Typography
                              variant='body2'
                              style={{ fontSize: '1rem', paddingTop: '1rem' }}
                            >
                              {data?.qaStatusText ? data?.qaStatusText : '-NA-'}
                            </Typography>
                          </Grid>
                        )}
                      </>
                    )}
                  </Grid>
                  {data?.progressBar && (
                    <Grid container style={{ padding: '1rem 0', overflowX: 'auto' }}>
                      <Grid item xs={12}>
                        <BatchProgressBar progressBar={data?.progressBar} />
                      </Grid>
                    </Grid>
                  )}
                </Grid>
                {loading === false ? (
                  <React.Fragment>
                    {/* Render batch information components based on feature access */}
                    {(this.props.fgBatchFeatures?.fgBatchGRInfo || this.props.isFromPoDashboard || this.props.isFromLogisticsDashboard || this.props.batchRowData) && data?.hasBatchData && (
                      <React.Fragment>
                        <General data={data} />
                        <hr />
                      </React.Fragment>
                    )}
                    {(this.props.fgBatchFeatures?.fgBatchInfo || this.props.isFromPoDashboard || this.props.isFromLogisticsDashboard || this.props.batchRowData) && data?.hasBatchData && (
                      <ProducedBatchInformation batchDetails={data} selectedBatch={this.state.selectedBatch} quickView />
                    )}
                    {(this.props.fgBatchFeatures?.fgBatchInfo || this.props.isFromPoDashboard || this.props.isFromLogisticsDashboard || this.props.batchRowData) && data?.hasBatchData && (
                      <ConsumedBatchInformation batchDetails={data} quickView />
                    )}
                    {/* Pre-Shipment Information section commented out
                    {(this.props.fgBatchFeatures?.fgBatchInfo || this.props.isFromPoDashboard || this.props.isFromLogisticsDashboard || this.props.batchRowData) && data?.hasBatchData && (
                      <PreShipmentInformation batchDetails={data} selectedBatch={this.state.selectedBatch} quickView />
                    )}
                    */}
                    {/* ASL Check Details section commented out
                    {(this.props.fgBatchFeatures?.fgBatchInfo || this.props.isFromPoDashboard || this.props.isFromLogisticsDashboard || this.props.batchRowData) && data?.hasBatchData && data?.aslDataList && data.aslDataList.length > 0 && (
                      <React.Fragment>
                        <ASLCheckDetails batchDetails={data} grnNumber={data?.BOGeneratedGRNNumber || data?.grnNumber} />
                      </React.Fragment>
                    )}
                    */}
                    
                    {/* GRN Information Section */}
                    {this.state.partialShippingDetails && this.state.partialShippingDetails.length > 0 && (
                      <React.Fragment>
                        <Grid 
                          container 
                          justifyContent="flex-start"
                          style={{ padding: '1rem', marginTop: '5px', marginBottom: '2px' }}
                        >
                          <Grid item xs={8} sm={12} md={12} className={classes.grid} style={{ marginLeft: '-10px' }}>
                            <Typography variant='h4' className={classes.title}>
                              {`${this.state.asnNumber ? 'IBD' : 'GRN'}`} Information
                            </Typography>
                            <span className={classes.borders}></span>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} lg={11} style={{ paddingBottom: '1rem' }}>
                          <TableContainer component={Paper} className={classes.tableContainer}>
                            <Table className={classes.table}>
                              <TableHead>
                                <TableRow className={classes.tableHeader}>
                                  <TableCell className={classes.headerCell} style={{ width: '200px', maxWidth: '200px' }}>{`${this.state.asnNumber ? 'IBD' : 'GRN'}`} Number</TableCell>
                                  <TableCell className={classes.headerCell} style={{ width: '200px', maxWidth: '200px', textAlign: "right" }}>Individual Shipment Quantity</TableCell>
                                  <TableCell className={classes.headerCell} style={{ width: '200px', maxWidth: '200px' }}>UoM</TableCell>
                                  <TableCell className={classes.headerCell} style={{ width: '200px', maxWidth: '200px' }}>{`${this.state.asnNumber ? 'IBD' : 'GRN'}`} Creation Date</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.partialShippingDetails.map((detail, index) => (
                                  <TableRow key={index} className={classes.tableRow}>
                                    <TableCell className={classes.tableCell} style={{ width: '200px', maxWidth: '200px' }}>
                                      {detail.shipmentNumber || 'N/A'}
                                    </TableCell>
                                    <TableCell className={classes.tableCell} style={{ width: '200px', maxWidth: '200px', textAlign: "right" }}>
                                      {detail.shippedQuantity || 'N/A'}
                                    </TableCell>
                                    <TableCell className={classes.tableCell} style={{ width: '200px', maxWidth: '200px' }}>
                                      {data?.batchUOM || 'N/A'}
                                    </TableCell>
                                    <TableCell className={classes.tableCell} style={{ width: '200px', maxWidth: '200px' }}>
                                      {detail.creationDate ? this.convertToLocaleDateTime(detail.creationDate) : 'N/A'}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                        <hr style={{marginTop: "15px" }} />
                      </React.Fragment>
                    )}
                    
                    {/* Post-Shipment Information section commented out
                    {(this.props.fgBatchFeatures?.fgBatchInfo || this.props.isFromPoDashboard || this.props.isFromLogisticsDashboard || this.props.batchRowData) && data?.hasBatchData && (
                      <PostShipmentInformation batchDetails={data} selectedBatch={this.state.selectedBatch} quickView />
                    )}
                    */}
                    {(this.props.fgBatchFeatures?.fgBatchShippingInfo || this.props.isFromPoDashboard || this.props.isFromLogisticsDashboard || this.props.batchRowData) && data?.hasBatchData && (data.SASLBatchStatusID === 9 || data.SASLBatchStatusID === 8) && (
                      <ShippingInformation batchDetails={data} currentStatusId={data.SASLBatchStatusID} quickView />
                    )}
                    
                    {/* <Grid
                      item
                      xs={8}
                      sm={12}
                      md={12}
                      className={classes.grid}
                      style={{ paddingTop: '1rem', paddingBottom: '0.7rem' }}
                    >
                      <Typography variant='h4' className={classes.title}>
                        Documents
                      </Typography>
                      <span className={classes.borders}></span>
                    </Grid>
                    <Grid item xs={12} lg={11}>
                      {sortedFiles && sortedFiles.filter(file => file?.customFileType !== "custom").length > 0 ? (
                        <TableContainer component={Paper} className={classes.tableContainer}>
                          <Table>
                            <TableHead>
                              <TableRow className={classes.tableHeader}>
                                <TableCell className={classes.headerCell}>Document Name</TableCell>
                                <TableCell className={classes.headerCell}>Document Received Date</TableCell>
                                <TableCell className={classes.headerCell}>Attached File</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {doubleSortedFiles.map((file, index) => {
                                if (file?.customFileType === "custom") return null;

                                let documentCategory = "File";
                                let fileName = "File";

                                switch (file?.customFileType) {
                                  case "BMR":
                                    documentCategory = "Consumption Pages";
                                    fileName = "Consumption Pages.PDF";
                                    break;
                                  case "COC":
                                    documentCategory = "CoC";
                                    fileName = "Certificate of Conformance.PDF";
                                    break;
                                  case "dsbatch_coa":
                                    documentCategory = "CoA";
                                    fileName = "Certificate of Analysis.PDF";
                                    break;
                                  case "eInvoice":
                                    documentCategory = "Invoice";
                                    fileName = "Invoice.PDF";
                                    break;
                                  case "packingList":
                                    documentCategory = "Packing List";
                                    fileName = "Packing List.PDF";
                                    break;
                                  case "proformaInvoice":
                                    documentCategory = "Proforma Invoice";
                                    fileName = "Proforma Invoice.PDF";
                                    break;
                                }

                                return (
                                  <TableRow key={index} className={classes.tableRow}>
                                    <TableCell className={classes.tableCell}>
                                      {documentCategory}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                      {formatDate(file.lastUpdatedDate)}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                      <a href="#" className={classes.link} onClick={() => this.handleDownloadFile(file.schrockenCustomFileID)}>
                                        {fileName}
                                      </a>
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : (
                        <Typography variant="body1" style={{ padding: "16px", paddingTop: '8px' }}>
                          No documents
                        </Typography>
                      )}
                    </Grid> */}
                    <Grid container justify='center'>
                     
                      <Grid
                        item
                        xs={4}
                        sm={4}
                        md={2}
                        style={{
                          textAlign: 'center',
                          padding: '1rem',
                        }}
                      >
                        <StyledButton
                          onClick={this.dialogClosClearData}
                          fullWidth
                        >
                          Close
                        </StyledButton>
                      </Grid>
                       {showApproveButton && (
                        <Grid
                          item
                          xs={4}
                          sm={4}
                          md={2}
                          style={{
                            textAlign: 'center',
                            padding: '1rem',
                          }}
                        >
                          <StyledButton
                            onClick={this.handleOpenApproveRejectBatch}
                            fullWidth
                          >
                            Approve/Reject
                          </StyledButton>
                        </Grid>
                      )}
                    </Grid>
                  </React.Fragment>
                ) : (
                  <Grid container justify='center'>
                    <div
                      style={{
                        textAlign: 'center',
                        marginTop: '25%',
                        minWidth: '60vw',
                      }}
                    >
                      <CircularProgress color='primary' thickness={7} />
                    </div>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </FullWidthContent>
        </Header>
        
        {this.state.openApproveRejectBatch && (
          <ApproveRejectConsumedBatch
            open={this.state.openApproveRejectBatch}
            onClose={this.handleCloseApproveRejectBatch}
            batchApprove={true}
            rowInfo={{
              batchDetails: {
                batchNumber: data?.vendorBatchNumber,
                vendorBatchNumber: data?.vendorBatchNumber,
                schrockenDeliveryScheduleBatchID: this.props.schrockenDeliveryScheduleBatchID,
                bomConsumptionAddedIndicator: data?.bomConsumptionAddedIndicator,
                batchSize: this.props.batchRowData?.batchSize,
                cmoBatchNumber: this.props.batchRowData?.cmoBatchNumber || data?.cmoBatchNumber,
              },
              scheduleLineDetails: {
                sponsorName: data?.sponsorOrgName,
                brandOwnerName: data?.brandOwnerName,
                cmoName: data?.cmoMember,
                vendorName: data?.vendorName,
                fgMaterialCode: this.props.batchRowData?.fgMaterialCode || data?.fgMaterialCode,
                fgMaterialName: this.props.batchRowData?.fgMaterialName || data?.fgMaterialName,
                targetQuantity: this.props.targetQuantity,
                committedQuantity: this.props.targetQuantity,
                targetQuantityUOM: data?.targetQuantityUOM,
                scheduleAgreementNumber: data?.scheduleAgreementNumber,
                vendorMosymphonyID: data?.vendorMosymphonyID,
                brandOwnerMosymphonyID: data?.brandOwnerMosymphonyID,
                schrockenSLID: data.schrockenSLID,
                cmoProductCode: data?.cmoProductCode,
                cmoProductDescription: data?.cmoProductDescription,
              }
            }}
            onRefresh={this.handleRefreshData}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  DsDetails: state.pcmp.common.sasl.DsDetails,
  fgBatchScreenAccess:
    state.pcmp.common.accessControl.screensAccess?.data.fgBatch,
  fgBatchFeatures:
    state.pcmp.common.accessControl.featuresAccess?.fgBatchFeatures,
});

export default withStyles(useStyles)(
  connect(mapStateToProps, {
    fetchDSBatchDetails,
    downloadCustomUploadedFile,
    getFeaturesAccess,
  })(QuickView)
);